import Link from "next/link";
import React from "react";
import { UnstyledLink } from "./UnstyledLink";

interface OptionalNextLinkProps {
    useNextRouter?: boolean;
    href?: string;
    target?: string;
    ariaLabel?: string;
    customLinkStyle?: React.CSSProperties;
}

export const OptionalNextLink: React.FC<React.PropsWithChildren<OptionalNextLinkProps>> = ({
    useNextRouter = true,
    href,
    children,
    target,
    ariaLabel,
    customLinkStyle
}) => {
    if (!href) return <>{children}</>;

    if (useNextRouter) {
        return (
            <Link href={href} style={{ textDecoration: "none", ...customLinkStyle }}>
                {children}
            </Link>
        );
    } else {
        return (
            <UnstyledLink href={href} target={target} aria-label={ariaLabel}>
                {children}
            </UnstyledLink>
        );
    }
};
